<!-- Vertical Menu (Fresh Rebuild) -->

<!-- Header / Logo -->
<div class="menu-header" *ngIf="config?.layout.menuPosition === 'Side'">
  <div class="logo-wrapper">
    <a [routerLink]="['/dashboard']" class="logo-link">
      <img [src]="logoUrl" alt="Logo" class="logo-icon" />
      <img [src]="logoTextUrl" alt="Intobee" class="logo-text" />
    </a>

    <!-- Toggles -->
    <button class="toggle-btn d-none d-lg-none d-xl-block" (click)="toggleSidebar()">
      <i class="ft-toggle-right" *ngIf="!config?.layout?.sidebar?.collapsed"></i>
      <i class="ft-toggle-left" *ngIf="config?.layout?.sidebar?.collapsed"></i>
    </button>
    <button class="close-btn d-block d-lg-block d-xl-none" (click)="CloseSidebar()">
      <i class="ft-x"></i>
    </button>
  </div>
</div>

<!-- Menu Content -->
<div class="menu-content main-menu-content">
  <ul class="menu-list navigation navigation-main" appSidebarDropdown>

    <!-- Loop through Items -->
    <li *ngFor="let item of menuItems" class="menu-item" [ngClass]="{'has-sub': item.submenu?.length > 0}"
      appSidebarlink [parent]="item.title" [path]="item.path" level="{{1}}" [hasSub]="item.submenu?.length > 0"
      [routerLinkActive]="item.submenu?.length === 0 ? 'active' : ''" [routerLinkActiveOptions]="{ exact: true }">

      <!-- 1. External Link -->
      <a *ngIf="item.isExternalLink" [href]="item.path" target="_blank" class="menu-link">
        <i [ngClass]="item.icon" class="menu-icon"></i>
        <span class="menu-text">{{ item.title | translate }}</span>
      </a>

      <!-- 2. Submenu Parent -->
      <a *ngIf="!item.isExternalLink && item.submenu?.length > 0" appSidebarAnchorToggle class="menu-link">
        <i [ngClass]="item.icon" class="menu-icon"></i>
        <span class="menu-text">{{ item.title | translate }}</span>
      </a>

      <!-- 3. Standard Link -->
      <a *ngIf="!item.isExternalLink && item.submenu?.length === 0" [routerLink]="item.path" class="menu-link">
        <i [ngClass]="item.icon" class="menu-icon"></i>
        <span class="menu-text">{{ item.title | translate }}</span>
      </a>

      <!-- Submenu List -->
      <ul *ngIf="item.submenu?.length > 0" class="submenu-list" appSidebarDropdown>
        <li *ngFor="let sub of item.submenu" class="submenu-item" appSidebarlink [path]="sub.path"
          parent="{{item.title}}" level="{{2}}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">

          <a *ngIf="!sub.isExternalLink" [routerLink]="sub.path" class="submenu-link">
            <i [ngClass]="sub.icon" class="submenu-icon"></i>
            <span class="submenu-text">{{ sub.title | translate }}</span>
          </a>

          <a *ngIf="sub.isExternalLink" [href]="sub.path" target="_blank" class="submenu-link">
            <i [ngClass]="sub.icon" class="submenu-icon"></i>
            <span class="submenu-text">{{ sub.title | translate }}</span>
          </a>
        </li>
      </ul>

    </li>
  </ul>
</div>